import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FileSignature } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// Non-blocking notice for Pro salons whose art. 28 agreement is pending.
// Never redirects: login/logout, legal pages, privacy export and support stay reachable.
export const DpaBanner = () => {
  const { user } = useAuth();
  const [st, setSt] = useState(null);
  const loc = useLocation();
  useEffect(() => {
    if (user?.role !== "client" || user?.plan !== "pro") return;
    api.get("/dpa/status").then((r) => setSt(r.data)).catch(() => setSt(null));
  }, [user?.role, user?.plan, loc.pathname]);
  if (!st || !["pending", "new_version_required"].includes(st.status) || loc.pathname === "/dashboard/accordo") return null;
  return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-2 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm" data-testid="dpa-banner">
      <div className="flex items-center gap-2">
        <FileSignature className="h-4 w-4 text-amber-700" />
        <span>
          {st.status === "new_version_required" ? "È disponibile una nuova versione dell'Accordo di nomina a responsabile (art. 28): va accettata per conto del salone." : "L'Accordo di nomina a responsabile (art. 28 GDPR) è in attesa di accettazione per conto del salone."}
          {st.enforcement_enabled ? " Fino ad allora le nuove lavorazioni restano sospese." : ""}
        </span>
      </div>
      <div className="flex gap-3">
        <Link to="/dashboard/accordo" className="font-semibold underline" data-testid="dpa-banner-link">Leggi e accetta</Link>
        <a href="mailto:info@marketingparrucchieri.info?subject=Accordo%20art.%2028" className="underline text-neutral-600" data-testid="dpa-banner-help">Non sono autorizzato / assistenza</a>
      </div>
    </div>
  );
};
